// /src/utils/authContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react'

const AuthContext = createContext()

const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

export { useAuth }

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [user, setUser] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  const logout = () => {
    localStorage.removeItem('adminToken')
    localStorage.removeItem('adminUser')
    setUser(null)
    setIsAuthenticated(false)
  }

  useEffect(() => {
    // Check for existing auth token on app load
    const token = localStorage.getItem('adminToken')
    const userData = localStorage.getItem('adminUser')
    
    if (token && userData) {
      try {
        const parsedUser = JSON.parse(userData)
        setUser(parsedUser)
        setIsAuthenticated(true)
      } catch (error) {
        console.error('Error parsing user data:', error)
        logout()
      }
    }
    
    setIsLoading(false)
  }, [])

  const login = (userData, token) => {
    localStorage.setItem('adminToken', token)
    localStorage.setItem('adminUser', JSON.stringify(userData))
    setUser(userData)
    setIsAuthenticated(true)
  }

  // Helper functions for role-based access
  const isSuperAdmin = () => user?.role === 'super_admin'
  const isAdmin = () => user?.role === 'admin' || user?.role === 'super_admin'
  const isViewer = () => user?.role === 'viewer' || user?.role === 'admin' || user?.role === 'super_admin'
  const canDelete = () => user?.role === 'super_admin'
  const canCreateUsers = () => user?.role === 'super_admin'

  const value = {
    isAuthenticated,
    user,
    isLoading,
    login,
    logout,
    isSuperAdmin,
    isAdmin,
    isViewer,
    canDelete,
    canCreateUsers
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
} 